module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.orderList), function(order, index) {
    return _c('div', {
      staticClass: "content-block"
    }, [_c('div', {
      attrs: {
        "id": order.id
      },
      on: {
        "click": function($event) {
          return _vm.goToOrderDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "35px"
      }
    }, [_c('span', {
      staticClass: "deep-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("订单编号：" + _vm._s(order.orderNo))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('span', {
      class: _vm.getStatusStyle(order)
    }, [_vm._v("\n        " + _vm._s(_vm.getOrderStatusText(order)))]), _vm._v(" "), _c('i', {
      staticClass: "icon-font emkt-icon-lujing",
      staticStyle: {
        "font-size": "12px"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    }), _vm._v(" "), (order.balanceType === _vm.emkt.BALANCE_TYPE_RESEARCH_GROUP) ? _c('div', [_c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "35px"
      }
    }, [_c('span', {
      staticClass: "deep-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v(_vm._s(order.orderPerson))]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("结算账户：" + _vm._s(order.researchGroupName))])]), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    })]) : _vm._e(), _vm._v(" "), _vm._l((order.itemList), function(item, i) {
      return _c('div', [_c('gc-order-product', {
        attrs: {
          "item": item,
          "order": order,
          "show-product-contract-no": _vm.showProductContractNo
        }
      })], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "full-split-line"
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "35px"
      }
    }, [_c('span', {
      staticClass: "light-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v(_vm._s(order.orderTime))]), _vm._v(" "), _c('div', {
      staticClass: "light-text-color"
    }, [_c('span', {
      staticClass: "light-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("共" + _vm._s(order.itemList.length) + "件商品")]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
      staticClass: "research-font-color",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.emkt.formatPrice(order.price)))])])]), _vm._v(" "), _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "35px",
        "justify-content": "flex-end",
        "align-items": "flex-start",
        "flex-wrap": "wrap"
      }
    }, [_vm._t("itemButton", null, null, order)], 2)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18bde554","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/order/components/GcOrderListBase.vue
// module id = 1552
// module chunks = 8